import { createAction, props } from '@ngrx/store';
import { Reason } from '../../models/Reason';

export const getReasons = createAction('[Reason] Get Reasons');
export const getReasonsSuccess = createAction(
  '[Reason] Get Reasons Success',
  props<{ reasons: Reason[] }>()
);
